<a
    class="guide-card pointer"
    [class.guide-card--resume]="variant === 'resume'"
    [class.guide-card--completed]="variant === 'completed'"
    (click)="onClick()"
    [style.background-color]="guide.categories?.[0]?.color || null"
>
    <img src="/assets/images/Cloud%201.png" class="guide-card-clouds" alt="" />
    <div class="guide-card-type">{{ typeLabel }}</div>
    <div class="guide-card-category">{{ categoryTitle || "" }}</div>
    <div class="guide-card-title">{{ guide.title }}</div>
    @if (showProgress) {
    <div class="guide-card-progress">
        @if (guide.status !== 'completed') {
        <div class="guide-card-progress-inner-wrapper">
            <img
                src="assets/icons/guide_proggress_wrapper.png"
                alt="progress icon"
            />
            <div class="guide-card-progress-value">{{ guide.progress }}</div>
            <div class="guide-card-progress-percentage">%</div>
        </div>
        } @if (guide.status === 'completed') {
        <div class="guide-card-progress-completed">
            <svg
                width="10"
                height="8"
                viewBox="0 0 10 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M4.22105 7.53487C3.61304 8.15638 2.63088 8.15638 2.02288 7.5268L0.315798 5.75911C-0.112922 5.31517 -0.105127 4.59679 0.339183 4.169C0.760108 3.74927 1.43047 3.76542 1.8358 4.18514L3.12196 5.51696L8.13409 0.326901C8.55501 -0.108967 9.23317 -0.108967 9.65409 0.326901L9.68527 0.359188C10.1062 0.795056 10.1062 1.50536 9.67748 1.94123L4.22105 7.53487Z"
                    fill="#2C2C2C"
                />
            </svg>
        </div>
        }
    </div>
    } @if (guide.image) {
    <img
        [src]="guide.image"
        class="guide-card-image"
        [class.progress_positioning]="
            guide.status === 'in_progress' || guide.status === 'completed'
        "
        [alt]="guide.title"
    />
    }
</a>
